import StartEndDurationUtils from "./start-end-duration-utils";
import DateTimeUtils from "../../utils/datetime-utils";
import {DependencyType} from "../../../model2/dependency/const";
import {momentRange} from "../../convert/moment-range";


// tipo neponyatno zachem on ne static ... no hren s nim
// navernoe eto daze horosho...

export default class StartEndDurationManager {


    constructor() {
    }

    _getWorkSchedule(userId:ID|null=null) {
        return userId ? gd.workSchedule.getUserWorkSchedule(userId) : gd.workSchedule.getCompanyWorkSchedule();
    }

    adjustWorkdaysDependencyLag(type:DependencyType, predecessorDates:any, successorDates:any, newLagValue: number, userId: ID |null = null) {
        let lagWorkdays, daysDifference = 0, newStart, newEnd;

        switch (type) {
            case gd.const.gantt.linkTypes.FINISH_START  :
            case gd.const.gantt.linkTypes.START_FINISH  :
                lagWorkdays     = this.calculateWorkdaysLag(predecessorDates.end, successorDates.start)
                break

            case gd.const.gantt.linkTypes.START_START   :
                lagWorkdays     = this.calculateWorkdaysLag(predecessorDates.start, successorDates.start)
                break

            case gd.const.gantt.linkTypes.FINISH_FINISH :
                lagWorkdays     = this.calculateWorkdaysLag(predecessorDates.end, successorDates.end)
                break
        }

        daysDifference  = newLagValue - lagWorkdays
        newStart        = this.addWorkdays(successorDates.start, daysDifference)
        newEnd          = this.addWorkdays(successorDates.end, daysDifference)

        return {
            start   : newStart,
            end     : newEnd
        }
    }

    calculateDependencyLag(type:DependencyType, predecessorDates:any, successorDates:any) {

        // console.print("calculateDependencyLag predecessor start=",predecessorDates.start,"end=", predecessorDates.end, "successor start=", successorDates.start, "end=", successorDates.end)

        let lagCalendarDays, lagWorkdays;
        let warning = false

        switch (type) {
            case gd.const.gantt.linkTypes.FINISH_START  :
            case gd.const.gantt.linkTypes.START_FINISH  :

                // not in use at the moment
                // // There is s problem here is successor start is holiday
                // // solution here is to find first working day... technically right thing would be
                // // fixing it it getDependencydates BUT we dont' have holidays here yet so apply patch here for now
                // //
                // const successorStartWorkingDate = this.findFirstWorkingDay(Moment.range(successorDates.start, successorDates.end))
                // lagWorkdays     = this.calculateWorkdaysLag(predecessorDates.end, successorStartWorkingDate);

                lagWorkdays     = this.calculateWorkdaysLag(predecessorDates.end, successorDates.start);
                lagCalendarDays = successorDates.start.diff(predecessorDates.end, 'days');

                // still not ideal... calendar days lag >0 workdays lag =0 ... not good
                // maybe good solution if calendar days lag>0 and workdays lag == 0 make workdays lag =1 ?
                // case when successor starts on weekend
                // patch issues - Experimental
                if (lagCalendarDays>0 && lagWorkdays===0) lagWorkdays=1

                warning         = lagWorkdays<0
                break;

            case gd.const.gantt.linkTypes.START_START   :
                lagWorkdays     = this.calculateWorkdaysLag(predecessorDates.start, successorDates.start);
                lagCalendarDays = successorDates.start.diff(predecessorDates.start, 'days');
                warning         = lagWorkdays<0
                break;

            case gd.const.gantt.linkTypes.FINISH_FINISH :
                lagWorkdays = this.calculateWorkdaysLag(predecessorDates.end, successorDates.end);
                lagCalendarDays = successorDates.end.diff(predecessorDates.end, 'days');
                warning         = lagWorkdays > 0
                break;

            default:
                console.warn("E98373 not implemnnted")
        }

        // console.log("dependency lag = ", {
        //     warning         : warning,
        //     calendarDays    : lagCalendarDays,
        //     workdays        : lagWorkdays
        // })

        return {
            warning         : warning,
            calendarDays    : lagCalendarDays,
            workdays        : lagWorkdays
        };
    }

    calculateOnMove = (originalStartDate:any, originalEndDate:any, scheduleDate:any, newStartDate:any, userId = null) => {
        const workSchedule = userId ? gd.workSchedule.getUserWorkSchedule(userId) : gd.workSchedule.getCompanyWorkSchedule();
        const durationWorkdays = workSchedule.calculateWorkdays(momentRange(originalStartDate, originalEndDate));

        const correctedStartDate = workSchedule.calculateStartDate(newStartDate, newStartDate.isBefore(originalStartDate,'day') ? -1 : 1);
        const newEndDate = workSchedule.calculateEndDate(correctedStartDate, durationWorkdays);
        const newScheduleDate = StartEndDurationUtils.calculateNewScheduleDate(correctedStartDate, newEndDate, scheduleDate);
        const duration = newEndDate.diff(correctedStartDate, 'days') + 1;

        return {
            startDate: correctedStartDate,
            endDate: newEndDate,
            durationWorkdays: durationWorkdays,
            durationCalendarDays: duration,
            scheduleDate: newScheduleDate
        }
    }

    calculateWorkdaysDurationChange = (originalStartDate:any, originalEndDate:any, scheduleDate:any, targetWorkdays:any, userId = null) => {
        const workSchedule = userId ? gd.workSchedule.getUserWorkSchedule(userId) : gd.workSchedule.getCompanyWorkSchedule();
        const newEndDate = workSchedule.calculateEndDate(originalStartDate, targetWorkdays);
        const newScheduleDate = StartEndDurationUtils.calculateNewScheduleDate(originalStartDate, newEndDate, scheduleDate);
        const duration = newEndDate.diff(originalStartDate, 'days') + 1;

        return {
            startDate: originalStartDate,
            endDate: newEndDate,
            durationWorkdays: targetWorkdays,
            durationCalendarDays: duration,
            scheduleDate: newScheduleDate
        }
    }

    // calculate number of work days in calendar days range
    calculateWorkdays = (startDate:any, endDate:any, userId = null) => {
        const start = typeof startDate === 'string' ? DateTimeUtils.dateToMoment(startDate) : startDate;
        const end = endDate ? typeof endDate === 'string' ? DateTimeUtils.dateToMoment(endDate) : endDate : startDate;

        const endIsBeforeStart = end ? end.isBefore(start, 'days') : false;
        const workSchedule = userId ? gd.workSchedule.getUserWorkSchedule(userId) : gd.workSchedule.getCompanyWorkSchedule();
        const durationWorkdays = start && end ? workSchedule.calculateWorkdays(momentRange(start, end)) : 1;

        return (endIsBeforeStart ? -1 : 1) * durationWorkdays;
    }

    calculateWorkdaysLag = (start:Moment, end:Moment, userId = null) => {

        if (!start || !end) {
            console.warn("missng start or end")
            return 0;
        }

        const workSchedule = userId ? gd.workSchedule.getUserWorkSchedule(userId) : gd.workSchedule.getCompanyWorkSchedule();

        const workdaysLag = workSchedule.calculateWorkdaysLag(momentRange(start, end));

        return workdaysLag
    }

    findFirstWorkingDay = (momentRange:DateRange, userId=null) => {
        const workSchedule = userId ? gd.workSchedule.getUserWorkSchedule(userId) : gd.workSchedule.getCompanyWorkSchedule();

        return workSchedule.findFirstWorkingDay(momentRange);
    }

    addWorkdays = (date:any, workdays:number, userId: ID |null = null) => {
        const workSchedule = userId ? gd.workSchedule.getUserWorkSchedule(userId) : gd.workSchedule.getCompanyWorkSchedule();
        return workSchedule.addWorkdays(date, workdays);
    }

    // return today (if working day) else next working day
    getCurrentOrNextWorkDay(userId:ID|null) {
        return this._getWorkSchedule(userId).getCurrentOrNextWorkDay()
    }

}